import { useState } from 'react';

interface LinkModalState {
  isOpen: boolean;
  url: string;
  title?: string;
}

export const useLinkModal = () => {
  const [modalState, setModalState] = useState<LinkModalState>({
    isOpen: false,
    url: '',
    title: undefined
  });

  const openModal = (url: string, title?: string) => {
    setModalState({
      isOpen: true,
      url,
      title
    });
  };

  const closeModal = () => {
    setModalState({
      isOpen: false,
      url: '',
      title: undefined
    });
  };

  return {
    ...modalState,
    openModal,
    closeModal
  };
};
